import { Injectable, NgZone } from "@angular/core";
import { AuthService } from "@auth";
import posthog from "posthog-js";
import { environment } from "src/environments/environment";


@Injectable({ providedIn: "root" })
export class PosthogService {

  constructor(
    private ngZone: NgZone,
    private authService: AuthService
  ) {
  }

  initPostHog() {
    this.ngZone.runOutsideAngular(() => {
      posthog.init(environment.posthog.apiKey, {
        api_host: environment.posthog.apiHost,
        defaults: '2025-05-24',
        person_profiles: 'identified_only',
        autocapture: false,
        disable_persistence: true,
        disable_session_recording: true,
        disable_surveys: true,
        capture_pageview: false,
        capture_pageleave: false,
        capture_performance: false,
      });
    });
  }

  trackPostHogEvent(eventName: string, baseProps: object) {
    var identityProps = {
        tenant: this.authService.currentOrganization!.name,
        username: this.authService.currentUserEmail,
    };
    var properties = {
        ...baseProps,
        ...identityProps,
    };
    posthog.capture(eventName, properties);
  }
}
